import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { TemplateDesignElement } from '../../design-element';
import {
  CommunicationTemplate,
  CommunicationTemplateViewControl,
  ConfirmationType,
  MassNotificationTemplate,
  MessageSettings
} from 'src/app/modules/communications/store/communications';
import { TemplateDesignerService } from 'src/app/modules/communications/services/template-designer.service';
import { TextElementSettings } from '../text-control/text-control-model';
import produce from 'immer';
import { UserProfileApiService } from '@app/modules/core/store/user-profile';
import * as fromAuth from 'src/app/modules/authentication/store/auth/auth.selectors';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-tts-text-control',
    templateUrl: './tts-text-control.component.html',
    styleUrls: ['./tts-text-control.component.scss'],
    standalone: false
})
export class TtsTextControlComponent implements OnInit, OnDestroy, TemplateDesignElement {
  @Input() index: number;
  @Input() messageSettings?: MessageSettings;
  @Input() template?: CommunicationTemplate;
  @Input() control?: CommunicationTemplateViewControl;
  @Input() set culture(value: string) {
    this._culture = value;
    this.loadData();
  }
  _culture: string;
  @Input() orgLanguages: string[];
  @Input() selected: boolean;
  @Output() settingsChanged = new EventEmitter<{ uId: string; settings: any }>();
  @Output() controlBusy = new EventEmitter();
  @Output() controlReady = new EventEmitter();

  editMode: boolean;
  messageText: string;
  showRichText: boolean = false;
  richTextValue: string;
  richTextOrPlaceHolder: string;
  private organizationUId: string;

  constructor(
    private store: Store<any>,
    private templateDesignerService: TemplateDesignerService,
    private userProfileApiService: UserProfileApiService
  ) {}

  ngOnInit(): void {
    this.store
      .select(fromAuth.selectUserContext)
      .pipe(take(1))
      .subscribe(uc => (this.organizationUId = uc.organizationUId));
  }

  ngOnDestroy(): void {}

  private getEditPlaceHolder(): string {
    if (!!this.templateDesignerService.staticTextTranslations?.['EDIT-TEXT-PLACEHOLDER'][this._culture]) {
      var defaultText = this.templateDesignerService.staticTextTranslations['EDIT-TEXT-PLACEHOLDER'][this._culture];
      return `<div style="font-size: 14px; font-family: Verdana, Geneva, Tahoma, sans-serif; font-weight: 400; color: #000000">${defaultText}</div>`;
    }

    return null;
  }

  onEditClick(): void {
    this.showRichText = true;
    this.controlBusy.emit();
  }

  updateRichText(text: string): void {
    this.showRichText = false;
    const control = produce(this.control, draftState => {
      if (!!!draftState.settings) {
        draftState.settings = {
          richText: {}
        } as TextElementSettings;
      }
      if (!draftState.settings.richText) {
        draftState.settings.richText = {};
      }
      draftState.settings.richText[this._culture] = text;
    });

    this.control = control;

    this.richTextValue = text;
    this.richTextOrPlaceHolder = this.richTextValue;
    this.settingsChanged.emit({ uId: this.control.uId, settings: control.settings });
  }

  getUserList(searchText, renderList) {
    this.userProfileApiService.getUsersForMention(this.organizationUId, searchText).subscribe(res => {
      const entries = res.data.map(p => ({ id: p.uId, value: `${p.displayName}` }));
      renderList(entries);
    });
  }

  cancelRichText(): void {
    this.showRichText = false;
    this.controlReady.emit();
  }

  loadSettings(): void {
    this.showRichText = false;
    this.editMode = true;
    this.loadData();
  }

  private loadData(): void {
    const settings: TextElementSettings = this.control?.settings;

    let richTextValue = this.templateDesignerService.getTranslateText(settings?.richText, this._culture);
    if (!!richTextValue) {
      this.richTextValue = richTextValue;
      this.richTextOrPlaceHolder = this.richTextValue;
    } else {
      this.richTextOrPlaceHolder = this.getEditPlaceHolder();
    }
  }

  saveSettings(): boolean {
    return true;
  }

  render(): void {
    this.editMode = false;
    this.loadData();
  }

  edit(): void {
    this.onEditClick();
  }

  setRuntimeData(data: any): void {}
}
